const BUSINESS_TYPE = {
  PERSONAL: 'personal',
}

export { BUSINESS_TYPE }
